import { useMemo } from "react"
import { useAppSelector } from "integrations/redux/hooks"
import {
    getLocalStorageValue,
    setLocalStorageValue,
    useLocalStorageValue,
} from "tools/store/localStorageRegistry"
import { LayerStatus } from "../layers/overlays/layerStatus"
import { selectMapOverlayStatus } from "./selectors"
import { OverlayKey, overlayKeys } from "./types"
import type { MapBackgroundViewType } from "./useMapStyles"

const localStorageKeyByViewType = {
    project: "mapOverlays",
    overview: "overviewMapOverlays",
    flightPreview: "mapOverlays",
} as const

export function useOverlays(viewType: MapBackgroundViewType) {
    const enabled = useLocalStorageValue(localStorageKeyByViewType[viewType])
    const status = useAppSelector(selectMapOverlayStatus)
    return useMemo(
        () =>
            Object.fromEntries(
                overlayKeys.map((key) => [
                    key,
                    { enabled: !!enabled[key], status: status[key] ?? "idle" },
                ])
            ) as Record<OverlayKey, { enabled: boolean; status: LayerStatus }>,
        [enabled, status]
    )
}

export function setOverlayEnabled(
    viewType: MapBackgroundViewType,
    key: OverlayKey,
    value: boolean
) {
    const localStorageKey = localStorageKeyByViewType[viewType]
    setLocalStorageValue(localStorageKey, {
        ...getLocalStorageValue(localStorageKey),
        [key]: value,
    })
}
